// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3px7h","errorLogs":"EditorFooter_errorLogs__STR_2"};